<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";
import DropZone from "@/components/widgets/dropZoneCsv.vue";
import {ref} from "vue";

export default {
  components: {
    DropZone,
    Loader, Layout, PageHeader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  data() {

    return {
      title: "Pedidos Shopee",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Pedidos Shopee",
          active: true
        }
      ],
      dataListAts: null,
      loading: true,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      erroPeriodo: '',
      filterSettings: { type: 'Excel' },
      toolbar: [
        { text: 'Importar', prefixIcon: 'e-expand', id: 'importarArquivo', align: 'Left', disabled: false },
        { text: 'Criar Financeiro', prefixIcon: 'e-text-wrap', id: 'criarFinanceiro', align: 'Left', disabled: false },
        { text: 'Abrir Financeiro', prefixIcon: 'e-group-2', id: 'abrirFinanceiro', align: 'Left', disabled: false },
        { tooltipText: 'Envio de Ordem de Coleta', prefixIcon: 'e-send', id: 'envioOrdemColeta', align: 'Left', disabled: true  },
        { tooltipText: 'Criar Pedido Baseado NF-e', prefixIcon: 'e-insert-right', id: 'criarPedido', align: 'Left', disabled: true  },
        { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
        { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' },
        { text: 'Search', tooltipText: 'Pesquisar'}
      ],
      toolbarPeds: [
        { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
        { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' }
      ],
      pageSetsAts: {
        pageSize: 5,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },
      showModalPedido: false,
      pedidoData: {},
      submittedCrFinanc: false,
      dtIniCrFinanc: null,
      dtFimCrFinanc: null,
      dataListPedidos: null,
      loadPedidos: false,
      atSelected: null,

      showModalImpPlan: false,
      submittedImpPlan: false,

    };
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  created() {

  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {

    confImpPlan(){
      console.log('confImpPlan')
      this.submittedImpPlan = true
      this.loading = true
      if (this.dropzoneFile.name){
        this.showModalImpPlan = false
        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)
        api.post(`${getBaseUrl()}api/movshptrkimpcsvelk`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.mediasData = res.data[0]
          this.loading = false
          if (res.data[0] === 'erro') {
            Swal.fire({
              position: "top-end",
              icon: `error`,
              title: `Erro ao importar planilha tipo ${res.data[1]}, revisar colunas:`,
              text: res.data[2],
              showConfirmButton: true,
            }).then(() => {
              this.loading = false
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações importadas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(res => {
              console.log(res)
              this.atualizaDataList()
            })
          }
        }).catch((err) => {
          console.log('erro axios_0')
          console.log(err)
          console.log('erro axios_1')
          console.log(err.response)
          console.log('erro axios_2')
          //console.log(err.response.status)
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: 'Tamanho máximo atingigo, favor reduzir o tamanho do arquivo ou entrar em contato com suporte',
            text: err,
            showConfirmButton: true,
          }).then(() => {
            this.loading = false
          })

        })
      }
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },

    confCriaFinanc(){
      console.log('confCriaFinanc')

      this.submittedCrFinanc = true
      if (this.dtIniCrFinanc && this.dtFimCrFinanc) {
        this.showModalFinanceiro = false
        // let listaNotas = this.dataGrid.getSelectedRowKeys()
        this.updating = true
        api.get(`${getBaseUrl()}api/movshptrkgfin`,{
          params: {
            // 'ids': listaNotas,
            'dtini': moment(this.dtIniPerFecha).format('YYYY-MM-DD'),
            'dtfim': moment(this.dtFimPerFecha).format('YYYY-MM-DD')
          }
        }).then(response => {
          console.log(response.data)
          this.updating = false
          // Swal.fire({
          //   position: 'top-end',
          //   icon: 'success',
          //   html: response.data['contLancs'] + ' Lançamentos selecionados <br>'
          //       + response.data['contSemMotor'] + ' Não possuiam motorista ou veículo <br>'
          //       + response.data['totalCriado'] + ' Registros financeiros criados com sucesso',
          //   showCancelButton: false,
          //   showConfirmButton: false,
          //   timer: 4000
          // }).then(() => {
          //   window.location.reload();
          // })
        })
      }

    },


    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      // console.log(args.item.id)
      if (args.item.id === 'criarFinanceiro') {
        console.log('criarFinanceiro')
        if (this.atSelected === null) {
          Swal.fire({
            position: 'top-end',
            icon: 'warning',
            title: 'Favor selecionar alguma AT para gerar o movimento financeiro.',
            showConfirmButton: false,
            timer: 2000,
          })
        } else {
          Swal.fire({
            position: "center",
            icon: "question",
            title: "Gerar Movimento Financeiro",
            text: "Esta operação é irreversível, tem certeza que deseja continuar?",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,
          }).then(result => {
            if (result.value) {
              console.log(result)
              this.loading = true
              this.dataListPedidos = null
              api.get(`${getBaseUrl()}api/movshptrkgfin2`,{
                params: {
                  'at': this.atSelected.at,
                }
              }).then(response => {
                console.log(response.data)
                this.atSelected = null
                this.loading = false

                Swal.fire({
                  position: 'top-end',
                  icon: 'success',
                  title: 'Total criado: ' +  response.data['totalCriado'] + ', sem motorista: ' + response.data['contSemMotor'] + ', lançamentos: ' + response.data['contLancs'],
                  showConfirmButton: false,
                  timer: 8000,
                })

                // window.location.reload()
              })
            }
          })
        }
      }
      else if (args.item.id === 'abrirFinanceiro') {
        console.log('abrirFinanceiro')
        const routeData = this.$router.resolve(`/movshptrkfins/list`)
        window.open(routeData.href, '_blank')
      }
      else if (args.item.id === 'exportExcel') {
        this.loading = true
        const fileProps = {
          fileName: 'movimentos.xlsx'
        }
        this.$refs.dataGridAts.excelExport(fileProps)
        this.loading = false
      }
      else if (args.item.text === 'exportCsv') {
        this.loading = true
        const fileProps = {
          fileName: 'movimentos.csv'
        }
        this.$refs.dataGridAts.csvExport(fileProps)
        this.loading = false
      }
      else if (args.item.id === 'importarArquivo') {
        console.log('importarArquivo')
        console.log('novaImpPlan')
        this.submittedImpPlan = false
        this.showModalImpPlan = true


      }
    },


    tbClickHandlerPeds: function(args) {
      console.log('tbClickHandlerPeds')
      console.log(args.item)
      if (args.item.id === 'exportExcel') {
        this.loading = true
        const fileProps = {
          fileName: 'pedidos.xlsx'
        }
        this.$refs.dataGridPedidos.excelExport(fileProps)
        this.loading = false
      }
      else if (args.item.text === 'exportCsv') {
        this.loading = true
        const fileProps = {
          fileName: 'pedidos.csv'
        }
        this.$refs.dataGridPedidos.csvExport(fileProps)
        this.loading = false
      }
    },


    abrirCte(chaveCte){
      console.log('abrirCte')
      console.log(chaveCte)
      this.showModalPedido = false
      this.loading = true
      api.get(`${getBaseUrl()}api/movcteid`, {
        params: {
          'chave': chaveCte
        }
      }).then(response => {
        console.log(response)
        if (response.data[0]) {
          console.log(response)
          const routeData = this.$router.resolve(`/movcte/editar/${response.data[0].id}`)
          window.open(routeData.href, '_blank')

        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'warning',
            title: 'Nenhum CT-e encontrado para a chave informada.',
            showConfirmButton: false,
            timer: 2000,
          })
        }
        this.loading = false
      })
    },

    recAtDblClick(evt){
      console.log('recAtDblClick')
      console.log(evt)
      // this.pedidoData = evt.rowData
      // this.showModalPedido = true
    },

    recPedDblClick(evt){
      console.log('recPedDblClick')
      console.log(evt)
      this.pedidoData = evt.rowData
      this.showModalPedido = true
    },

    recAtClick(evt){
      console.log('recordeClick')
      console.log(evt.data.at)
      this.atSelected = evt.data
      this.loadPedidos = true
      this.dataListPedidos = null
      const paramsReq = {
        'at': evt.data.at
      }
      api.get(`${getBaseUrl()}api/movspepedelk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data[0])
        this.dataListPedidos = {
          result: response.data[0],
          count: response.data[1],
        }
        this.loadPedidos = false
      })
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      let difDias = moment(this.dtFimFiltro).diff(moment(this.dtIniFiltro), 'days')
      console.log(difDias)
      if (difDias < 31) {
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
          'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        }))
        this.showModalPeriodo = false
        this.atualizaDataList()
      } else {
        this.erroPeriodo = 'Diferença entre data inicial e final deve ser menor que 31 dias, caso necessário um período maior favor entrar em contato com suporte.'
      }
    },


    atualizaDataList(page, pageSize, search){
      console.log('atualizaDataList')
      this.loading = true

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros) {
        let perIniPadrao = moment(new Date()).startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).endOf('month').format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }
      const paramsReq = {
        'page': page,
        'pageSize': pageSize,
        'search': search,
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
      }
      api.get(`${getBaseUrl()}api/movspetrkelk`, {
        params: paramsReq
      }).then(response => {
        // console.log('response.bases')
        // console.log(response.data[0])
        let resAts = response.data[0]
        resAts.forEach(at => {
          at.total_pedidos = parseInt(0)
          at.total_pedidos_aberto = parseInt(0)
          at.total_pedidos_finalizado = parseInt(0)
          at.status_perc = '0%'
        })


        this.dataListAts = {
          result: resAts,
          count: response.data[1],
        }
        this.pageSetsAts.totalRecordsCount = response.data[1]
        this.pageSetsAts.currentPage = page
        this.pageSetsAts.pageSize = pageSize



        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
        this.title = `(${this.pageSetsAts.totalRecordsCount}) Pedidos Shopee: ${dtIniFormated} - ${dtFimFormated}`
        this.loading = false
      })
    },

    changePage(args){
      console.log('changePage')
      // console.log(args)
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaDataList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    dataBoundAts: function() {
      this.$refs.dataGridAts.autoFitColumns([])
    },

    dataBoundPedidos: function() {
      this.$refs.dataGridPedidos.autoFitColumns([])
    },


    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>


    <div class="card">
      <div class="card-body">
        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a
                v-b-toggle.accordion-1
                class="text-dark"
                href="javascript: void(0);"
            >AT's</a>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
          <b-card-body>
            <Loader v-if="loading" style="min-height: 300px;">
            </Loader>
            <div v-if="!loading">
              <ejs-grid :dataSource="dataListAts"
                        ref="dataGridAts"
                        :actionBegin="changePage"
                        :allowFiltering="false"
                        :allowPdfExport="true"
                        :allowExcelExport="true"
                        :allowPaging="true"
                        :enableColumnVirtualization="true"
                        :recordDoubleClick="recAtDblClick"
                        :rowSelected="recAtClick"
                        :dataBound="dataBoundAts"
                        :pageSettings="pageSetsAts"
                        :toolbar="toolbar"
                        :toolbarClick="tbClickHandler"
                        :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                        :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                <e-columns>
                  <e-column field="base" headerText="Base" textAlign="Left" width="150"></e-column>
                  <e-column field="at" headerText="AT" textAlign="Left"></e-column>
                  <e-column field="total" headerText="Total Pedidos" width="120" textAlign="Right"></e-column>
                  <e-column field="total_pedidos_aberto" headerText="Em Aberto" width="120" textAlign="Right"></e-column>
                  <e-column field="total_pedidos_finalizado" headerText="Finalizado" width="120" textAlign="Right"></e-column>
                  <e-column field="status_perc" headerText="Status" width="120" textAlign="Right"></e-column>
                  <e-column field="entrega" headerText="Entrega" type="date" format="dd/MM/yyyy HH:mm" textAlign="Right" width="auto"></e-column>
                  <e-column field="financ" headerText="Financeiro" textAlign="Right"></e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </b-card-body>
        </b-collapse>


        <b-card-header header-tag="header" role="tab">
          <h6 class="m-0">
            <a
                v-b-toggle.accordion-2
                class="text-dark"
                href="javascript: void(0);"
            >Pedidos {{ atSelected != null ? atSelected.at : '' }}:</a>
          </h6>
        </b-card-header>
        <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
          <b-card-body>
            <Loader v-if="loadPedidos" style="min-height: 100px;">
            </Loader>
            <div v-if="!loadPedidos && dataListPedidos">
              <ejs-grid :dataSource="dataListPedidos"
                        ref="dataGridPedidos"
                        :actionBegin="changePage"
                        :allowFiltering="false"
                        :allowPdfExport="true"
                        :allowExcelExport="true"
                        :enableColumnVirtualization="true"
                        :recordDoubleClick="recPedDblClick"
                        :dataBound="dataBoundPedidos"
                        :toolbar="toolbarPeds"
                        :toolbarClick="tbClickHandlerPeds"
                        :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                        :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                <e-columns>
                  <e-column field="pedido" headerText="Pedido" textAlign="Left"></e-column>
                  <e-column field="em_3pl" headerText="3PL" textAlign="Left"></e-column>
                  <e-column field="em_cep" headerText="CEP" textAlign="Right"></e-column>
                  <e-column field="em_distancia" headerText="Distância" textAlign="Right"></e-column>
                  <e-column field="em_horario_entrega" headerText="Entrega" type="date" format="dd/MM/yyyy HH:mm" textAlign="Right" width="auto"></e-column>
                  <e-column field="em_motorista" headerText="Motorista" textAlign="Left"></e-column>
                  <e-column field="em_motorista_ultimo_id" headerText="Motor.ID" textAlign="Left"></e-column>
                  <e-column field="em_packages" headerText="Packages" textAlign="Right"></e-column>
                  <e-column field="em_rota" headerText="Rota" textAlign="Right"></e-column>
                  <e-column field="em_station_name" headerText="Estação" textAlign="Left"></e-column>
                  <e-column field="em_status_helper" headerText="Helper" textAlign="Left"></e-column>
                  <e-column field="em_stops" headerText="Stops" textAlign="Left"></e-column>
                  <e-column field="em_veiculo" headerText="Veículo" textAlign="Left"></e-column>
                  <e-column field="em_xd_origem" headerText="Origem" textAlign="Left"></e-column>

                  <e-column field="at_agencia" headerText="Agência" textAlign="Left"></e-column>
                  <e-column field="at_agencia_tempo" headerText="Tempo Ag." textAlign="Left"></e-column>
                  <e-column field="at_cep" headerText="CEP" textAlign="Left"></e-column>
                  <e-column field="at_criador" headerText="Criador" textAlign="Left"></e-column>
                  <e-column field="at_entrega" headerText="Entrega AT" textAlign="Left"></e-column>
                  <e-column field="at_inicio" headerText="Início" textAlign="Left"></e-column>
                  <e-column field="at_motorista_id" headerText="Motor.ID" textAlign="Left"></e-column>
                  <e-column field="at_numero_to" headerText="Número TO" textAlign="Left"></e-column>
                  <e-column field="at_numero_to_assoc" headerText="TO Assoc." textAlign="Left"></e-column>
                  <e-column field="at_operador" headerText="Operador" textAlign="Left"></e-column>
                  <e-column field="at_station_name" headerText="Estação" textAlign="Left"></e-column>
                  <e-column field="at_status" headerText="Status" textAlign="Left"></e-column>
                  <e-column field="at_status_rejeicao" headerText="Rejeição" textAlign="Left"></e-column>
                  <e-column field="at_task_id" headerText="TaskID" textAlign="Left"></e-column>


                  <e-column field="ro_bairro" headerText="Bairro" textAlign="Left"></e-column>
                  <e-column field="ro_cep" headerText="CEP" textAlign="Left"></e-column>
                  <e-column field="ro_cidade" headerText="Cidade" textAlign="Left"></e-column>
                  <e-column field="ro_endereco" headerText="Endereço" textAlign="Left"></e-column>
                  <e-column field="ro_endereco_tipo" headerText="Tipo" textAlign="Left"></e-column>
                  <e-column field="ro_estacao" headerText="Estação" textAlign="Left"></e-column>
                  <e-column field="ro_parada" headerText="Parada" textAlign="Left"></e-column>
                  <e-column field="ro_sequencia" headerText="Sequência" textAlign="Left"></e-column>
                  <e-column field="ro_task_ids" headerText="TaskIDs" textAlign="Left"></e-column>
                  <e-column field="ro_total_pedidos" headerText="Pedidos" textAlign="Left"></e-column>


                </e-columns>
              </ejs-grid>
            </div>
          </b-card-body>
        </b-collapse>
      </div>
    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="perexib">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <b-alert v-if="this.erroPeriodo !== ''"  show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i> {{ erroPeriodo }}
      </b-alert>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="xl" :title="'Detalhes Pedido Shopee ' + this.pedidoData._id" v-model="showModalPedido" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label>Exportação AT</label>
        </div>
      </div>

      <div class="row">

        <div class="col-md-3">
          <div class="mb-3">
            <label for="pedido">Pedido</label>
            <input
                id="pedido"
                v-model="pedidoData.pedido"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>


        <div class="col-md-3">
          <div class="mb-3">
            <label for="at_agencia">Agência</label>
            <input
                id="at_agencia"
                v-model="pedidoData.at_agencia"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>


        <div class="col-md-3">
          <div class="mb-3">
            <label for="at_agencia_tempo">Tempo Agência</label>
            <input
                id="at_agencia_tempo"
                v-model="pedidoData.at_agencia_tempo"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-3">
          <div class="mb-3">
            <label for="at_cep">CEP</label>
            <input
                id="at_cep"
                v-model="pedidoData.at_cep"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_cidade">Cidade</label>
            <input
                id="at_cidade"
                v-model="pedidoData.at_cidade"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_cluster">Cluster</label>
            <input
                id="at_cluster"
                v-model="pedidoData.at_cluster"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_conclusao">Conclusão</label>
            <input
                id="at_conclusao"
                v-model="pedidoData.at_conclusao"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_criador">Criador</label>
            <input
                id="at_criador"
                v-model="pedidoData.at_criador"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_entrega">Entrega</label>
            <input
                id="at_entrega"
                v-model="pedidoData.at_entrega"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_inicio">Início</label>
            <input
                id="at_inicio"
                v-model="pedidoData.at_inicio"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_motorista">Motorista</label>
            <input
                id="at_motorista"
                v-model="pedidoData.at_motorista"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_motorista_id">ID Motorista</label>
            <input
                id="at_motorista_id"
                v-model="pedidoData.at_motorista_id"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_motorista_tempo">Tempo Motorista</label>
            <input
                id="at_motorista_tempo"
                v-model="pedidoData.at_motorista_tempo"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_numero_to">Número TO</label>
            <input
                id="at_numero_to"
                v-model="pedidoData.at_numero_to"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_numero_to_assoc">Número TO Ass.</label>
            <input
                id="at_numero_to_assoc"
                v-model="pedidoData.at_numero_to_assoc"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_operador">Operador</label>
            <input
                id="at_operador"
                v-model="pedidoData.at_operador"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_ponto_refer">Ponto Ref.</label>
            <input
                id="at_ponto_refer"
                v-model="pedidoData.at_ponto_refer"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_station_name">Estação</label>
            <input
                id="at_station_name"
                v-model="pedidoData.at_station_name"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_status">Status</label>
            <input
                id="at_status"
                v-model="pedidoData.at_status"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_status_rejeicao">Status Rejeição</label>
            <input
                id="at_status_rejeicao"
                v-model="pedidoData.at_status_rejeicao"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_task_id">Task ID</label>
            <input
                id="at_task_id"
                v-model="pedidoData.at_task_id"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="at_tipo_risco">Tipo Risco</label>
            <input
                id="at_tipo_risco"
                v-model="pedidoData.at_tipo_risco"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

      </div>

      <div class="row mb-2">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="cte">CT-e</label>
            <input
                id="cte"
                v-model="pedidoData.cte"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

      </div>


      <div class="col-md-12">
        <div class="mb-3">
          <label>Exportação Romaneio</label>
        </div>
      </div>

      <div class="row mb-2">

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_bairro">Bairro</label>
            <input
                id="ro_bairro"
                v-model="pedidoData.ro_bairro"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_cep">CEP</label>
            <input
                id="ro_cep"
                v-model="pedidoData.ro_cep"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_cidade">Cidade</label>
            <input
                id="ro_cidade"
                v-model="pedidoData.ro_cidade"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_endereco">Endereço</label>
            <input
                id="ro_endereco"
                v-model="pedidoData.ro_endereco"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_estacao">Estação</label>
            <input
                id="ro_estacao"
                v-model="pedidoData.ro_estacao"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_parada">Parada</label>
            <input
                id="ro_parada"
                v-model="pedidoData.ro_parada"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_sequencia">Sequência</label>
            <input
                id="ro_sequencia"
                v-model="pedidoData.ro_sequencia"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_task_ids">Task ID's</label>
            <input
                id="ro_task_ids"
                v-model="pedidoData.ro_task_ids"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_total_pedidos">Total Pedidos</label>
            <input
                id="ro_total_pedidos"
                v-model="pedidoData.ro_total_pedidos"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="ro_veiculo_tipo">Tipo Veículo</label>
            <input
                id="ro_veiculo_tipo"
                v-model="pedidoData.ro_veiculo_tipo"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

      </div>


      <div class="col-md-12">
        <div class="mb-3">
          <label>E-mail</label>
        </div>
      </div>

      <div class="row mb-2">

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_3pl">3PL</label>
            <input
                id="em_3pl"
                v-model="pedidoData.em_3pl"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_cep">CEP</label>
            <input
                id="em_cep"
                v-model="pedidoData.em_cep"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_distancia">Distância</label>
            <input
                id="em_distancia"
                v-model="pedidoData.em_distancia"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_horario_entrega">Entrega</label>
            <input
                id="em_horario_entrega"
                v-model="pedidoData.em_horario_entrega"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_motorista">Motorista</label>
            <input
                id="em_motorista"
                v-model="pedidoData.em_motorista"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_motorista_ultimo_id">Motorista Últ.ID</label>
            <input
                id="em_motorista_ultimo_id"
                v-model="pedidoData.em_motorista_ultimo_id"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_packages">Packages</label>
            <input
                id="em_packages"
                v-model="pedidoData.em_packages"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_rota">Rota</label>
            <input
                id="em_rota"
                v-model="pedidoData.em_rota"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_station_name">Estação</label>
            <input
                id="em_station_name"
                v-model="pedidoData.em_station_name"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_status_helper">Helper</label>
            <input
                id="em_status_helper"
                v-model="pedidoData.em_status_helper"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_stops">Stops</label>
            <input
                id="em_stops"
                v-model="pedidoData.em_stops"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_veiculo">Veículos</label>
            <input
                id="em_veiculo"
                v-model="pedidoData.em_veiculo"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="em_xd_origem">XD Origem</label>
            <input
                id="em_xd_origem"
                v-model="pedidoData.em_xd_origem"
                type="text"
                :disabled="true"
                class="form-control"/>
          </div>
        </div>

      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPedido = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button variant="success" class="ms-1" @click="abrirCte(pedidoData.cte)">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Abrir CT-e
        </b-button>
      </div>

    </b-modal>


    <b-modal title="Importar Planilha" v-model="showModalImpPlan" centered hide-footer>
      <div>
        <div class="card-body">
          <h4 class="card-title">Selecionar planilha</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedImpPlan && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpPlan = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImpPlan">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>

<style>

.sts-el {
  background-color: rgba(78,59,0,0.5);
}
.sts-cf {
  background-color: rgba(0,58,78,0.5);
}
.sts-enp {
  background-color: rgba(33,78,0,0.5);
}
.sts-ecr {
  background-color: rgba(146,20,0,0.5);
}
.sts-eat {
  background-color: rgba(146,20,0,0.5);
}
.sts-ned {
  background-color: rgba(146,73,0,0.5);
}
.sts-nef {
  background-color: rgba(146,20,0,0.5);
}
.sts-sct {
  background-color: rgba(146,111,0,0.5);
}
.sts-cct {
  background-color: rgba(0,58,78,0.5);
}
.sts-tra {
  background-color: rgba(146,20,0,0.5);
}
.sts-can {
  background-color: rgba(146,20,0,0.5);
}


</style>
